import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import {
  Http,
  Headers,
  Request,
  Response,
  XHRBackend,
  RequestOptions,
  RequestOptionsArgs
} from '@angular/http';

// rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Reducer & Actions
import * as fromAuth from '../../auth/reducers';
import * as AuthActions from '../../auth/actions/auth.actions';

// Services
import { TranslationService } from '../../translation/services/translation.service';

@Injectable()
export class HttpService extends Http {

  // Constructor
  constructor(
    backend: XHRBackend,
    options: RequestOptions,
    public store: Store<fromAuth.State>,
    public translationService: TranslationService
  ) {
    super(backend, options);
  }

  // Private Error Handler
  private errorHandler(error) {
    return _throw(error.json());
  }

  // Private Method To Modify The Options
  private authOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
    // Variable to store the session token
    let auth_token: string = null;
    const app_language: string = this.translationService.currentLang;

    // Selecting the session token
    this.store.select(state => state.auth.login.token).do(token => auth_token = token).subscribe().unsubscribe();

    // If we have a token, we need to send it as Authorization Header
    if (auth_token && options) {
      options.headers.append('Authorization', auth_token);
    } else if (auth_token && !options) {
      options = new RequestOptions({ headers: new Headers() });
      options.headers.append('Authorization', auth_token);
    } else if (!options) {
      options = new RequestOptions({ headers: new Headers() });
    }
    options.headers.append('Referrer-Policy', 'unsafe-url');

    // Add language
    if (app_language && options) options.headers.append('Accept-Language', app_language);

    // Return new options
    return options;
  }

  // Refresh session time
  private refreshSessionTime(): void {
    this.store.dispatch(new AuthActions.RefreshSessionExpiration(new Date().getTime()));
  }

  // Extending POST Method
  public post(url: string, body?: any, options?: RequestOptionsArgs): Observable<Response> {
    // Modifying the options
    options = this.authOptions(options);

    // Returning the supper.post
    return super.post(url, body, options)
      .map(response => {
        this.refreshSessionTime();
        return response.json();
      })
      .catch(this.errorHandler);
  }

  // Extending GET Method
  public get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    // Modifying the options
    options = this.authOptions(options);

    // Returning the super.GET
    return super.get(url, options)
      .map(response => {
        // Refresh session time except for notification
        if (url.indexOf('notification/notification/user-notifications') === -1) this.refreshSessionTime();
        return response.json();
      })
      .catch(this.errorHandler);
  }

  // Extending PUT Method
  public put(url: string, body?: any, options?: RequestOptionsArgs): Observable<Response> {
    // Modifying the options
    options = this.authOptions(options);

    // Returning the supper.put
    return super.put(url, body, options)
      .map(response => {
        this.refreshSessionTime();
        return response.json();
      })
      .catch(this.errorHandler);
  }

  // Extending DELETE Method
  public delete(url: string, body?: any, options?: RequestOptionsArgs): Observable<Response> {
    // Modifying the options
    options = this.authOptions(options);

    // Add body
    options.body = body;

    // Returning the supper.delete
    return super.delete(url, options)
      .map(response => {
        this.refreshSessionTime();
        return response.json();
      })
      .catch(this.errorHandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/http.service.ts